// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"bcef9012","827":"109a3825","906":"5202e4c9","972":"e94a291b"}[chunkId] + ".chunk.css";
};